import {
  DB_UNMOUNT_ITEM,
  DB_DESCRIBE_ITEM,
  DB_GET_DATA,
  DB_CREATE_ITEM,
  DB_GET_ITEM,
  DB_UPDATE_ITEM,
} from '../actions/DbActions';

const INITIAL_STATE = {
  pageName: '',
  data: [],
  item: {},
  meta: {},
  attachments: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case DB_DESCRIBE_ITEM:
      return {
        ...state,
        meta: action.payload.data.meta,
        description: action.payload.data.description,
        pageName: action.meta.pageName,
      };

    case DB_GET_ITEM:
      return {
        ...state,
        item: action.payload.data,
      };

    case DB_GET_DATA:
      return {
        ...state,
        data: action.payload.data.list,
        attachments: action.payload.data.attachments,
      };

    case DB_UNMOUNT_ITEM:
      return INITIAL_STATE;

    case DB_CREATE_ITEM:
    case DB_UPDATE_ITEM:
    default:
      return state;
  }
}
